import { defineMessages } from 'react-intl';

export default defineMessages({
  thisSectionRelatedToMedicalExpenses: {
    id: 'fastCover.optimumMedicalBenefits.thisSectionRelatedToMedicalExpenses',
    defaultMessage: 'The section relates to medical expenses such as doctors visits, prescriptions or hospitalizations and similar services.',
  },
  whatExpensesAreYouClaimingFor: {
    id: 'fastCover.optimumMedicalBenefits.whatExpensesAreYouClaimingFor',
    defaultMessage: 'What expenses are you claiming for?',
  },
  isRequired: {
    id: 'fastCover.optimumMedicalBenefits.isRequired',
    defaultMessage: '{defaultMessage} is required',
  },
  yes: {
    id: 'fastCover.optimumMedicalBenefits.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.optimumMedicalBenefits.no',
    defaultMessage: 'No',
  },
  checkboxDoctorVisit: {
    id: 'fastCover.optimumMedicalBenefits.checkboxDoctorVisit',
    defaultMessage: "Doctor's Visit",
  },
  headerOutpatientPhysicianFees: {
    id: 'fastCover.optimumMedicalBenefits.headerOutpatientPhysicianFees',
    defaultMessage: 'Outpatient Physician Fees',
  },
  addItem: {
    id: 'fastCover.optimumMedicalBenefits.addItem',
    defaultMessage: 'Add Expense',
  },
  descriptionOfExpense: {
    id: 'fastCover.optimumMedicalBenefits.descriptionOfExpense',
    defaultMessage: 'Description of Expense',
  },
  dateOfExpense: {
    id: 'fastCover.optimumMedicalBenefits.dateOfExpense',
    defaultMessage: 'Date of Expense',
  },
  amountClaimed: {
    id: 'fastCover.optimumMedicalBenefits.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },
  currency: {
    id: 'fastCover.optimumMedicalBenefits.currency',
    defaultMessage: 'Currency',
  },
  providerName: {
    id: 'fastCover.optimumMedicalBenefits.providerName',
    defaultMessage: 'Provider Name',
  },
  checkEventDate: {
    id: 'fastCover.optimumMedicalBenefits.checkEventDate',
    defaultMessage: '{defaultMessage} is not a valid date',
  },
  expenseFor: {
    id: 'fastCover.optimumMedicalBenefits.expenseFor',
    defaultMessage: 'Expense For',
  },
  selectInsuredForExpense: {
    id: 'fastCover.optimumMedicalBenefits.selectInsuredForExpense',
    defaultMessage: 'Please select the insured(s) for this expense',
  },

  // Diagnostic Tests
  checkboxDiagnosticTests: {
    id: 'fastCover.optimumMedicalBenefits.checkboxDiagnosticTests',
    defaultMessage: 'Diagnostic Tests',
  },
  headerDiagnosticTests: {
    id: 'fastCover.optimumMedicalBenefits.headerDiagnosticTests',
    defaultMessage: 'Diagnostic Tests',
  },

  // Prescription Drugs
  checkboxPrescriptionDrugs: {
    id: 'fastCover.optimumMedicalBenefits.checkboxPrescriptionDrugs',
    defaultMessage: 'Prescription Drugs',
  },
  headerPrescriptionDrugs: {
    id: 'fastCover.optimumMedicalBenefits.headerPrescriptionDrugs',
    defaultMessage: 'Prescription Drugs',
  },

  // Ambulance Services
  checkboxAmbulanceServices: {
    id: 'fastCover.optimumMedicalBenefits.checkboxAmbulanceServices',
    defaultMessage: 'Ambulance Services',
  },
  questionGroundAmbulance: {
    id: 'fastCover.optimumMedicalBenefits.questionGroundAmbulance',
    defaultMessage: 'Is your invoice for a ground ambulance?',
  },
  headerGroundAmbulance: {
    id: 'fastCover.optimumMedicalBenefits.headerGroundAmbulance',
    defaultMessage: 'Ground Ambulance',
  },
  questionAirAmbulance: {
    id: 'fastCover.optimumMedicalBenefits.questionAirAmbulance',
    defaultMessage: 'Is your invoice for an Air Ambulance?',
  },
  headerAirAmbulance: {
    id: 'fastCover.optimumMedicalBenefits.headerAirAmbulance',
    defaultMessage: 'Air Ambulance',
  },
  headerOtherAmbulance: {
    id: 'fastCover.optimumMedicalBenefits.headerOtherAmbulance',
    defaultMessage: 'Other Types of Ambulances',
  },

  // Hospitalization
  checkboxHospitalization: {
    id: 'fastCover.optimumMedicalBenefits.checkboxHospitalization',
    defaultMessage: 'Hospitalization',
  },
  headerHospitalFees: {
    id: 'fastCover.optimumMedicalBenefits.headerHospitalFees',
    defaultMessage: 'Hospital Fees',
  },
  headerInpatientPhysicianFees: {
    id: 'fastCover.optimumMedicalBenefits.headerInpatientPhysicianFees',
    defaultMessage: 'Physician Fees while hospitalized',
  },
  headerXrayLabsDiagnostics: {
    id: 'fastCover.optimumMedicalBenefits.headerXrayLabsDiagnostics',
    defaultMessage: 'Expenses for X-Ray, Labs, or other diagnostics while hospitalized',
  },
  headerEmergencyAirTransportation: {
    id: 'fastCover.optimumMedicalBenefits.headerEmergencyAirTransportation',
    defaultMessage: 'Emergency Air Transportation that was approved by us in advance',
  },
  headerAirfareReturnHome: {
    id: 'fastCover.optimumMedicalBenefits.headerAirfareReturnHome',
    defaultMessage: 'Airfare to Return Home For Treatment Benefit that was approved by us in advance',
  },
  headerFamilyTransportation: {
    id: 'fastCover.optimumMedicalBenefits.headerFamilyTransportation',
    defaultMessage: 'Family Transportation expenses approved by us in advance',
  },
  headerFamilyTransportationMealsAccommodation: {
    id: 'fastCover.optimumMedicalBenefits.headerFamilyTransportationMealsAccommodation',
    defaultMessage: 'Family Transportation Meals and accommodation costs approved by us in advance',
  },
  headerMedicalAttendant: {
    id: 'fastCover.optimumMedicalBenefits.headerMedicalAttendant',
    defaultMessage: 'Medical Attendant that was approved by us in advance',
  },
  tooltipMedicalAttendant: {
    id: 'fastCover.optimumMedicalBenefits.tooltipMedicalAttendant',
    defaultMessage: 'This is only available if you have claimed Emergency Air Transportation benefit or the Airfare to Return Home for treatment benefit.',
  },
  headerReturnOfTravellingCompanion: {
    id: 'fastCover.optimumMedicalBenefits.headerReturnOfTravellingCompanion',
    defaultMessage: 'Return of Travelling Companion that was approved by us in advance',
  },
  tooltipReturnOfTravellingCompanion: {
    id: 'fastCover.optimumMedicalBenefits.tooltipReturnOfTravellingCompanion',
    defaultMessage: 'This is only available if you have claimed Emergency Air Transportation benefit, the Airfare to Return Home for treatment benefit, or the Repatriation benefit.',
  },
  headerOutOfPocketExpenses: {
    id: 'fastCover.optimumMedicalBenefits.headerOutOfPocketExpenses',
    defaultMessage: 'Out-Of-Pocket Expenses',
  },
  tooltipOutOfPocketExpenses: {
    id: 'fastCover.optimumMedicalBenefits.tooltipOutOfPocketExpenses',
    defaultMessage: 'Up to $150 per day to a maximum of $1,000 for your commercial accommodation, meals, telephone calls, internet charges, taxi fare, parking charges, bus fare and rental car under the circumstances listed in your policy document.',
  },
  headerReturnToUSA: {
    id: 'fastCover.optimumMedicalBenefits.headerReturnToUSA',
    defaultMessage: 'Return to USA',
  },
  headerEscortOfChildren: {
    id: 'fastCover.optimumMedicalBenefits.headerEscortOfChildren',
    defaultMessage: 'Escort of Children',
  },
  headerReturnOfVehicle: {
    id: 'fastCover.optimumMedicalBenefits.headerReturnOfVehicle',
    defaultMessage: 'Return of Vehicle',
  },
  tooltipReturnOfVehicle: {
    id: 'fastCover.optimumMedicalBenefits.tooltipReturnOfVehicle',
    defaultMessage: 'Payable only when pre-approved by TuGo when a doctor determines you are incapable of continuing your trip by vehicle.',
  },
  headerReturnOfVehicleCommercialAgency: {
    id: 'fastCover.optimumMedicalBenefits.headerReturnOfVehicleCommercialAgency',
    defaultMessage: 'Charges for a commercial agency to return an owned or rented vehicle',
  },
  headerReturnOfVehicleFamilyMemberFriend: {
    id: 'fastCover.optimumMedicalBenefits.headerReturnOfVehicleFamilyMemberFriend',
    defaultMessage: 'Airfare, gas, meals and/or accommodation related to your family member or friend returning your vehicle.',
  },

  // Essential Medical Equipment
  checkboxEssentialMedicalEquipment: {
    id: 'fastCover.optimumMedicalBenefits.checkboxEssentialMedicalEquipment',
    defaultMessage: 'Essential Medical Equipment',
  },
  tooltipEssentialMedicalEquipment: {
    id: 'fastCover.optimumMedicalBenefits.tooltipEssentialMedicalEquipment',
    defaultMessage: 'Expenses related to the cost of renting essential medical equipment such as crutches or wheelchair.',
  },
  headerEssentialMedicalEquipment: {
    id: 'fastCover.optimumMedicalBenefits.headerEssentialMedicalEquipment',
    defaultMessage: 'Essential Medical Equipment',
  },

  // Private Duty Nursing
  checkboxPrivateDutyNursing: {
    id: 'fastCover.optimumMedicalBenefits.checkboxPrivateDutyNursing',
    defaultMessage: 'Private Duty Nursing',
  },
  tooltipPrivateDutyNursing: {
    id: 'fastCover.optimumMedicalBenefits.tooltipPrivateDutyNursing',
    defaultMessage: 'Private duty nursing must be performed by an RN other than a family member when ordered in writing by the attending physician.',
  },
  headerPrivateDutyNursing: {
    id: 'fastCover.optimumMedicalBenefits.headerPrivateDutyNursing',
    defaultMessage: 'Private Duty Nursing',
  },

  // Fracture Treatment (standalone checkbox)
  checkboxFractureTreatmentStandalone: {
    id: 'fastCover.optimumMedicalBenefits.checkboxFractureTreatmentStandalone',
    defaultMessage: 'Fracture Treatment',
  },
  tooltipFractureTreatmentStandalone: {
    id: 'fastCover.optimumMedicalBenefits.tooltipFractureTreatmentStandalone',
    defaultMessage: 'This can include the cost of x-rays, reexamination by a physician, casting, re-casting and cast removal. Fracture benefit does not apply if you have claimed Airfare to Return Home for Treatment.',
  },
  headerFractureTreatmentStandalone: {
    id: 'fastCover.optimumMedicalBenefits.headerFractureTreatmentStandalone',
    defaultMessage: 'Fracture Treatment',
  },

  // Maternity Benefits
  checkboxMaternityBenefits: {
    id: 'fastCover.optimumMedicalBenefits.checkboxMaternityBenefits',
    defaultMessage: 'Maternity Benefits',
  },
  dateOfConception: {
    id: 'fastCover.optimumMedicalBenefits.dateOfConception',
    defaultMessage: 'Please enter the date of conception:',
  },
  dateOfConceptionTooltip: {
    id: 'fastCover.optimumMedicalBenefits.dateOfConceptionTooltip',
    defaultMessage: 'Conception means the date your pregnancy began, not when you discovered you were pregnant',
  },
  anticipatedDueDate: {
    id: 'fastCover.optimumMedicalBenefits.anticipatedDueDate',
    defaultMessage: 'Please enter your anticipated due date:',
  },
  headerRoutinePreNatalCare: {
    id: 'fastCover.optimumMedicalBenefits.headerRoutinePreNatalCare',
    defaultMessage: 'Routine Pre-Natal Care',
  },
  headerComplicationsOfPregnancy: {
    id: 'fastCover.optimumMedicalBenefits.headerComplicationsOfPregnancy',
    defaultMessage: 'Complications of Pregnancy',
  },

  // Dental Services
  checkboxDentalServices: {
    id: 'fastCover.optimumMedicalBenefits.checkboxDentalServices',
    defaultMessage: 'Dental Services',
  },
  dentalServicesDentalAccident: {
    id: 'fastCover.optimumMedicalBenefits.dentalServicesDentalAccident',
    defaultMessage: 'Dental Accident (result of a blow to the face)',
  },
  dentalServicesDentalPainOther: {
    id: 'fastCover.optimumMedicalBenefits.dentalServicesDentalPainOther',
    defaultMessage: 'Dental pain other than accident',
  },

  // Professional Services
  checkboxProfessionalServices: {
    id: 'fastCover.optimumMedicalBenefits.checkboxProfessionalServices',
    defaultMessage: 'Professional Services',
  },
  professionalServicesDescription: {
    id: 'fastCover.optimumMedicalBenefits.professionalServicesDescription',
    defaultMessage: 'These benefits are only eligible when they are ordered by a physician at the time of, and as a result of your emergency.',
  },
  professionalServicesPhysiotherapist: {
    id: 'fastCover.optimumMedicalBenefits.professionalServicesPhysiotherapist',
    defaultMessage: 'Physiotherapist',
  },
  professionalServicesChiropractor: {
    id: 'fastCover.optimumMedicalBenefits.professionalServicesChiropractor',
    defaultMessage: 'Chiropractor',
  },
  professionalServicesChiropodist: {
    id: 'fastCover.optimumMedicalBenefits.professionalServicesChiropodist',
    defaultMessage: 'Chiropodist',
  },
  professionalServicesOsteopath: {
    id: 'fastCover.optimumMedicalBenefits.professionalServicesOsteopath',
    defaultMessage: 'Osteopath',
  },
  professionalServicesPodiatrist: {
    id: 'fastCover.optimumMedicalBenefits.professionalServicesPodiatrist',
    defaultMessage: 'Podiatrist',
  },
  professionalServicesAcupuncturist: {
    id: 'fastCover.optimumMedicalBenefits.professionalServicesAcupuncturist',
    defaultMessage: 'Acupuncturist',
  },
  professionalServicesOptometrist: {
    id: 'fastCover.optimumMedicalBenefits.professionalServicesOptometrist',
    defaultMessage: 'Optometrist',
  },
  professionalServicesSelectOneRequired: {
    id: 'fastCover.optimumMedicalBenefits.professionalServicesSelectOneRequired',
    defaultMessage: 'Please select at least one professional service or uncheck Professional Services.',
  },

  // Accidental Death and Dismemberment Benefits
  checkboxAccidentalDeathAndDismembermentBenefits: {
    id: 'fastCover.optimumMedicalBenefits.checkboxAccidentalDeathAndDismembermentBenefits',
    defaultMessage: 'Accidental Death and Dismemberment Benefits',
  },
  headerAccidentalDeathAndDismemberment24HourAccident: {
    id: 'fastCover.optimumMedicalBenefits.headerAccidentalDeathAndDismemberment24HourAccident',
    defaultMessage: '24 Hour Accident',
  },
  tooltipAccidentalDeathAndDismemberment24HourAccident: {
    id: 'fastCover.optimumMedicalBenefits.tooltipAccidentalDeathAndDismemberment24HourAccident',
    defaultMessage:
      'Death or dismemberment as a result of an accident sustained during the period of coverage while riding as a fare-paying passenger, or while entering or leaving a lawfully operated licensed common carrier. Coverage is also applicable to insured children under two years accompanied by a fare paying passenger.',
  },

  // Expenses Related to Death (Standard VTC Medical Benefits)
  checkboxExpensesRelatedToDeath: {
    id: 'fastCover.optimumMedicalBenefits.checkboxExpensesRelatedToDeath',
    defaultMessage: 'Expenses Related to Death',
  },
  tooltipExpensesRelatedToDeath: {
    id: 'fastCover.optimumMedicalBenefits.tooltipExpensesRelatedToDeath',
    defaultMessage:
      'Expenses related to death are payable only when pre-approved by us. Charges for funeral expenses, coffin or urn are not eligible for reimbursement.',
  },
  headerExpensesRelatedToDeathReturnOfRemains: {
    id: 'fastCover.optimumMedicalBenefits.headerExpensesRelatedToDeathReturnOfRemains',
    defaultMessage: 'Return of remains to home country',
  },
  headerExpensesRelatedToDeathBurialOrCremationAtPlaceOfDeath: {
    id: 'fastCover.optimumMedicalBenefits.headerExpensesRelatedToDeathBurialOrCremationAtPlaceOfDeath',
    defaultMessage: 'Burial or Cremation at Place of Death',
  },
  headerExpensesRelatedToDeathTransportationOfFamilyMemberToIdentifyBody: {
    id: 'fastCover.optimumMedicalBenefits.headerExpensesRelatedToDeathTransportationOfFamilyMemberToIdentifyBody',
    defaultMessage: 'Transportation of Family Member to Identify Remains when required',
  },
  checkboxOtherUnrelatedBenefit: {
    id: 'fastCover.optimumMedicalBenefits.checkboxOtherUnrelatedBenefit',
    defaultMessage: 'Other (unrelated to any benefit listed above)',
  },
  headerOtherUnrelatedBenefit: {
    id: 'fastCover.optimumMedicalBenefits.headerOtherUnrelatedBenefit',
    defaultMessage: 'Other (unrelated to any benefit listed above)',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.OptimumMedicalBenefits/messages.js